module.exports = __webpack_public_path__ + "static/media/warning.16c12d8d.svg";